import styled from 'styled-components';

export const Container = styled.div`
  border-left: 3px solid;
  border-right: 3px solid;
`;
